<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <aviso-mei v-if="isMei()"></aviso-mei>
    <nota-fiscal v-else :substituicao="true"></nota-fiscal>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/dados/app.config.json";
import NotaFiscal from "@/router/views/nota_fiscal/components/nota-fiscal";
import AvisoMei from "@/router/views/nota_fiscal/components/aviso-mei";

export default {
  page: {
    title: "Substituir Nota Fiscal",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    NotaFiscal,
    AvisoMei
  },
  computed: {
    empresa: {
      get: function () {
        if (this.$store.state.auth.currenEmpresa) {
          return this.$store.state.auth.currenEmpresa;
        } else {
          return {eco_tributacao: null}
        }
      },
    },
  },
  data() {
    return {
      title: "Substituir Nota Fiscal Eletrônica de Serviço NFS-e",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'NFS-e',
          href: '/contribuinte/solicitacao',
        },
        {
          text: 'Substituir',
          active: true,
        },
      ],
    };
  },
  methods: {
    isMei() {
      const eco_tributacao = parseInt(this.empresa.eco_tributacao);
      return eco_tributacao === 1;
    }
  }
}
</script>

